const baseRouter = '/';

const color = {
    themeLight: {
        primary: '#135ea9',
        bgColor: '#ffffff',
        bgColor_2: '#f5f5f5',
        text: '#333333',
        text_reverse: '#ffffff',
        border: '#d4d4d4',
        overlay: '#fffffff5',
        overlay_2: '#ffffffcc',
    },
    themeDark: {
        primary: '#135ea9',
        bgColor: '#333333',
        bgColor_2: '#d9d9d9',
        text: '#ffffff',
        text_reverse: '#333333',
        border: '#d4d4d4',
        overlay: '#000000cc',
        overlay_2: '#000000f5',
    },
    primary: '#135ea9',
    primary_o: '#135ea9f5',
    black: '#333333',
    black_o: '#9a9a9a',
    light: '#ffffff',
    light_o: '#bbbbbb'
}

export {
    color,
    baseRouter
}